// Human-facing metadata for the API capabilities a personal access token can
// carry. Keys must match the registry in app/models/api_capability.rb exactly
// — the API validates against it.

// Write capabilities a team admin can enable and a coach token can carry.
export const API_WRITE_CAPABILITIES = [
  {
    key: 'events:write',
    label: 'Create and edit events',
    description: 'Add tournaments, dual meets, and other events to the team calendar and update them. Practices, scrambles, and private lessons can\'t be changed through the API, and events can\'t be deleted.',
  },
  {
    key: 'prospects:write',
    label: 'Create and edit leads',
    description: 'Add lead families and prospects, update their details, log contact notes, and move leads forward through the pipeline. Deleting leads is never allowed through the API.',
  },
  {
    key: 'reports:write',
    label: 'Create reports',
    description: 'Request report generation — the same reports available on the Reports page.',
  },
];

// Areas a limited-read token can be allowed to read. Reads need no team
// opt-in — they can only narrow what the token's profile already sees.
export const API_READ_CAPABILITIES = [
  {
    key: 'events:read',
    label: 'Events and locations',
    description: 'The team calendar and locations. Attendees, invites, and bookings are never included.',
  },
  {
    key: 'prospects:read',
    label: 'Leads',
    description: 'Lead families, prospects, their notes, and the pipeline summary.',
  },
  {
    key: 'reports:read',
    label: 'Reports',
    description: 'Reports on the Reports page and their full results. Reports can include rosters, contact details, and payments, so this is broad access.',
  },
];

// Mirrors ApiCapability.implied_read: a write implies reading the same area.
export function impliedReadFor(writeKey) {
  const readKey = writeKey.replace(/:write$/, ':read');
  return API_READ_CAPABILITIES.some((c) => c.key === readKey) ? readKey : null;
}
